// extracted by mini-css-extract-plugin
module.exports = {"definition":"MobileChapterControls__definition","chapter-button-size":"MobileChapterControls__chapter-button-size","root":"MobileChapterControls__root","buttons":"MobileChapterControls__buttons","chapterNumbers":"MobileChapterControls__chapterNumbers","otherButtons":"MobileChapterControls__otherButtons","divider":"MobileChapterControls__divider","controls":"MobileChapterControls__controls"};
    if(module.hot) {
      // 1790535734198
      var cssReload = require("/var/lib/jenkins/workspace/Player_master/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  